import $ from 'jquery';
import 'slider-pro';

export const initSliderPro = () => {

    // let rtime;
    // let timeout = false;
    // const delta = 200;

    const initSlider = () => {
        $('#sliderContent--main').sliderPro({
            width: '100%',
            //height: '400px',
            autoHeight: true,
            aspectRatio: 3,
            arrows: true,
            buttons: true,
            fade: false,
            autoplay: true,
        });
    };

    // const resizeSliderAfterWindowResized = () => {
    //     if (new Date() - rtime < delta) {
    //         setTimeout(resizeSliderAfterWindowResized, delta);
    //     } else {
    //         timeout = false;
    //         $('#sliderContent--main').sliderPro('destroy');
    //         initSlider();
    //     }
    // };

    initSlider();
    // $(window).resize(function() {
    //     rtime = new Date();
    //     if (timeout === false) {
    //         timeout = true;
    //         setTimeout(resizeSliderAfterWindowResized, delta);
    //     }
    //     $('#sliderContent--main').sliderPro('destroy');
    //     initSlider();
    // });

}